import React from 'react'
import styles from './ValuePropTwoColumn.module.scss'
import classNames from 'classnames'
type Props = {
  children: React.ReactElement<React.ComponentProps<any>, any>
  image: string
  imagePosition?: string
}
const ValuePropTwoColumn = ({ image, children, imagePosition }: React.PropsWithChildren<Props>) => {
  return (
    <div className={styles.twoColumnWrapper}>
      <div
        className={classNames(
          {
            [styles.imagePositionRight]: imagePosition === 'right',
          },
          styles.row
        )}
      >
        <img className={styles.image} src={image} />
        <div className={styles.text}>{children}</div>
      </div>
    </div>
  )
}

export default ValuePropTwoColumn
